import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { TipoProyectosTrabajoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class TipoProyectosTrabajoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getTipoProyectosTrabajoService(): Observable<BodyListResponse<TipoProyectosTrabajoDTO>> {
    return this.http.get<BodyListResponse<TipoProyectosTrabajoDTO>>(API_URL + '/api/v1/tipoProyectosTrabajo/todos');
  }

  guardarTipoProyectosTrabajoService(tipoProyectosTrabajoDTO: TipoProyectosTrabajoDTO): Observable<BodyResponse<TipoProyectosTrabajoDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/tipoProyectosTrabajo', tipoProyectosTrabajoDTO);
  }

  getTipoProyectosTrabajoPorCodigoTipoPlanesTrabajoService(codigoTipoPlanesTrabajo: string): Observable<BodyResponse<TipoProyectosTrabajoDTO>> {
    return this.http.get<BodyResponse<TipoProyectosTrabajoDTO>>(API_URL + '/api/v1/tipoProyectosTrabajo/' + codigoTipoPlanesTrabajo);
  }
}
